export default __webpack_public_path__ + "images/170a223e04ab24ee5c4760b3c4b69cba-los_angeles_desktop.webp";